module.exports = __webpack_public_path__ + "img/sharebag.c2235345.png";